import { render, staticRenderFns } from "./ScreenGroupNewModal.vue?vue&type=template&id=0775c2cd&"
import script from "./ScreenGroupNewModal.vue?vue&type=script&lang=js&"
export * from "./ScreenGroupNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports